<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="$t('view-Favlist.title')"
      />

      <div
        v-if="$store.state.favlist.items.length === 0"
        class="row mt-5"
      >
        <div class="col-20 text-center font-weight-bold">
          {{ $t('view-Favlist.empty.list') }}
        </div>
      </div>
      <div
        v-else
        class="row std-wrapper"
      >
        <div class="col-20 px-4 mt-4">
          <influencer-list
            :list="$store.state.favlist.items"
            :show-remove-from-favlist-button="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfluencerList from './influencer-list/List'

export default {
  components: {
    'influencer-list': InfluencerList
  },
  beforeMount () {
    this.$store.dispatch('favlist/get').catch(() => {})
  }
}
</script>

<style scoped>

</style>
